module.exports = __webpack_public_path__ + "img/gbp.da0ce475.svg";